import { IpisFormElement } from "@eljouren/domain";
import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistInformationElementBuilder from "./ChecklistInformationElementBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
  question: IpisFormElement.InformationType;
}

const ChecklistInformationElementEditor = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistInformationElementBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.editElement({ id: props.question.id, newValues: values });
        props.closeForm();
      }}
      defaultValues={props.question}
    />
  );
};

export default ChecklistInformationElementEditor;
